module.exports = __webpack_public_path__ + "resources/img/img_docuone3_m.625d6f20bfbd6c536c75c4e5f2c7a077.png";